import * as React from 'react';

import AlertModalContainer from '../../components/alertModal/AlertModalContainer';
import LoadMask from '../../components/loadMask';
import { Redirect } from 'react-router-dom';
import MenuBar from '../../components/menuBar/MenuBar';
import OverviewBreadcrumb from '../../components/overviewSearchBar/overviewBreadcrumb/OverviewBreadcrumb';
import InfoModal from '../../components/searchBox/infoModal/InfoModal';
import PropTypes from 'prop-types';
import CancelPnrDetail from './components/cancelPnrDetail/CancelPnrDetails';
import './CancelPnrPage.css';

const I18n = require('i18n-react').default;

const propTypes = {
  location: PropTypes.object
};

const defaultProps = {
  showLoading: false
};

export default class CancelPnrPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isRedirect: false,
      urlRedirect: ''
    };
  }

  componentDidMount() {     
    this.setState({
      pnrData: this.props.location.state.pnrDataDetail,
      showLoading: false,
      cancelData:this.props.location.state.cancelData,
      azulNumber : this.props.location.state.azulNumber,
      breadcrumbDetails: this.props.location.state.breadcrumbDetails
    });    
  }  

  handleCancel = () => {  
  };

  handleChangeTrip = () => {
    this.setState({
      isLoading: true
    });

    setTimeout(() => {
      this.setState({
        isLoading: false,
        isRedirect: true,
        urlRedirect: 'flightChangeSelection'
      });
    }, 2000);
  };

  showModal(message) {
    this.setState({
      openModal: true,
      messageInfo: message
    });
  }

  closeModal = () => {
    this.setState({
      openModal: false
    });
  };  

  render() {
    const { isLoading } = this.state; 
    return (
      <div className="CancelPnrPage">
        {isLoading && (
          <LoadMask text={I18n.translate('message.checkingChangeAvailable').toString()} />
        )}
        <MenuBar hideChangeSearch={true} />
        <OverviewBreadcrumb
          id="componentOverviewBreadcrumb"
          steps={
            this.state.breadcrumbDetails? 
            [
            'features.breadcrumb.reservation',
            'features.breadcrumb.details',
            'features.breadcrumb.cancellation'            
           ] : 
           [
            'features.breadcrumb.reservation',
            'features.breadcrumb.cancellation'            
           ]
        
        }
          actual="features.breadcrumb.cancellation"
        />
        <div className="body-min-height bg-white padding-eight-36">
          <div className="section__outer">
            {this.state.pnrData && (
                  <CancelPnrDetail
                    data={this.state.pnrData}
                    afterCancel={false}
                    refundTaxOnly={false}
                    addPayment={this.addPayment}
                    handleCancel={this.handleCancel}
                    handleChangeTrip={this.handleChangeTrip}
                    cancelData={this.state.cancelData}
                    azulNumber = {this.state.azulNumber}
                  />
                )}
          </div>
        </div>
        <AlertModalContainer
          title={I18n.translate('message.caution').toString()}
          message={I18n.translate('message.changeReservation').toString()}
          visible={false}
          closeModal={() => {}}
        />
        <AlertModalContainer
          title={I18n.translate('message.caution').toString()}
          message={I18n.translate('message.unexpectedServerError').toString()}
          visible={false}
          closeModal={() => {}}
        />
        <InfoModal
          id="modalError"
          message={this.state.messageInfo}
          showModal={this.state.openModal}
          close={this.closeModal}
          ref={c => {
            this.modalError = c;
          }}
        />
        {this.state.isRedirect ? (
          <Redirect
            push
            to={{
              pathname: this.state.urlRedirect,
              state: {
                pnrId:this.state.pnrData.pnrId,
                pnrNumber: this.state.pnrData.pnrNumber
              }
            }}
          />
        ) : null}
      </div>
    );
  }
}

CancelPnrPage.propTypes = propTypes;
CancelPnrPage.defaultProps = defaultProps;


// WEBPACK FOOTER //
// ./src/page/cancelPnr/CancelPnrPage.jsx